import { render, staticRenderFns } from "./RadioField.vue?vue&type=template&id=09cc7272&scoped=true&"
import script from "./RadioField.vue?vue&type=script&lang=js&"
export * from "./RadioField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cc7272",
  null
  
)

export default component.exports